import { render, staticRenderFns } from "./Transactionpage.vue?vue&type=template&id=35564353&scoped=true"
import script from "./Transactionpage.vue?vue&type=script&lang=js"
export * from "./Transactionpage.vue?vue&type=script&lang=js"
import style0 from "./Transactionpage.vue?vue&type=style&index=0&id=35564353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35564353",
  null
  
)

export default component.exports